import { useContext, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import * as H from 'history'
import { ContentBody, ContentHeader } from 'components/shared/content'
import {
    ActionTableCell,
    CheckboxTableRow,
    ExTable,
    SelectionFixedFooter,
    TableBody,
    TableHead,
    TableWrapper,
    useMultipleCheckForm,
} from 'components/shared/widget'
import { useFetchReagentItemsApi } from 'api/reagent_item'
import { ReagentItem, ReagentItemForm, ReagentItemSearchForm } from 'entities/reagent_item'
import { Pagination } from 'components/shared/pagination'
import { useForm, useQuery } from 'utils/hooks'
import { SearchConditionView } from 'components/shared/search_drawer'
import { GlobalStateContext } from 'contexts/global_state_context'
import { reagentItemColumnInfoList, ReagentItemTableData } from './reagent_item_table'
import { TableHeads, useDisplaySetting } from 'components/shared/display_setting'
import qs from 'qs'
import { useState } from 'react'
import { EditReagentItemForm, MergeReagentItemForm, NewReagentItemForm } from './reagent_item_form'
import { Flex } from 'components/shared/flex'
import { MasterDataContext } from 'contexts/master_data_context'
import { Button } from 'react-bootstrap'
import { useFetchReagentsApi } from 'api/reagent'
import moment from 'moment'

type Props = {
    history: H.History
}

const ReagentItemsPage = (props: Props) => {
    const globalState = useContext(GlobalStateContext)
    const masterDate = useContext(MasterDataContext)
    const query = useQuery<ReagentItemSearchForm>()
    const searchForm = useForm<ReagentItemSearchForm>({ ...query, ordering: '-reagent_item_delivered_date,-reagent_item_created_at' })
    const api = useFetchReagentItemsApi(searchForm)
    const multipleCheckForm = useMultipleCheckForm<ReagentItem>()
    const reagentItemDisplaySetting = useDisplaySetting(
        reagentItemColumnInfoList(searchForm, !query.reagentId || query.reagentId.split(',').length !== 0),
        'ReagentItem'
    )
    const [selectedReagentItem, setSelectedReagentItem] = useState<ReagentItem>({})
    const [showEdit, setShowEdit] = useState<boolean>(false)
    const reagentsApi = useFetchReagentsApi()
    const mergeReagentItemForm = useForm<ReagentItemForm>({ deliveredDate: moment().format('YYYY-MM-DD'), price: 0, openedDate: moment().format('YYYY-MM-DD') })
    const [showMerge, setShowMerge] = useState<boolean>(false)

    useEffect(() => {
        api.execute()
        reagentsApi.execute()
    }, [])

    const handleClickRemoveFilter = (key: keyof ReagentItemSearchForm): void => {
        searchForm.update((f) => {
            delete f[key]
        })
    }

    useEffect(() => {
        const queryParams = qs.stringify({ ...searchForm.object, page: api.pageSet.page, perPage: api.pageSet.perPage })
        if (props.history.location.search.replace('?', '') !== queryParams) {
            props.history.replace(`reagent_items?${queryParams}`)
        }
    }, [searchForm.object])

    const handleClickEdit = (reagentItem: ReagentItem) => {
        setSelectedReagentItem(reagentItem)
        setShowEdit(true)
    }

    return (
        <>
            <MergeReagentItemForm
                form={mergeReagentItemForm}
                reagents={reagentsApi.response.results}
                show={showMerge}
                onClose={() => setShowMerge(false)}
                onComplete={() => {
                    api.execute()
                    setShowMerge(false)
                }}
            />
            <EditReagentItemForm
                reagentItem={selectedReagentItem}
                show={showEdit}
                onClose={() => setShowEdit(false)}
                onComplete={() => {
                    api.execute()
                    setShowEdit(false)
                }}
            />

            <ContentHeader
                headerTitle={(reagentsApi.response.results.find((r) => r.id == query.reagentId)?.name ?? '') + ' 試薬ロット一覧'}
                left={
                    <>
                        {/* <CopyTableButton /> */}
                        {query.reagentId && query.reagentId.split(',').length === 1 && (
                            <NewReagentItemForm
                                onComplete={() => {
                                    api.execute()
                                    masterDate.reloadReagentItems()
                                }}
                                reagentId={Number(query.reagentId)}
                            />
                        )}
                        <SearchConditionView
                            searchForm={searchForm}
                            onClickRemoveButton={handleClickRemoveFilter}
                            hiddenSearchParams={['reagentId', 'reagent_kind']}
                        />
                    </>
                }
                right={<>{/* <DisplaySettingModal displaySettings={displaySettings} /> */}</>}
            />
            <Flex style={{ marginTop: 5 }} alignItems="center" justifyContent="space-between">
                <div></div>
                <Flex alignItems="center">
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                    <div style={{ minWidth: 140, textAlign: 'right' }}>総件数： {api.response.count.toLocaleString()}件</div>
                </Flex>
            </Flex>
            <ContentBody>
                <TableWrapper showFooter={multipleCheckForm.ids().length > 0} contentHeaderCount={1.3}>
                    <ExTable className="sticky-table">
                        <TableHead>
                            <CheckboxTableRow head allCheck allItems={api.response.results} multipleCheckForm={multipleCheckForm} showEdit>
                                <ActionTableCell th width={60} />
                                <TableHeads displaySetting={reagentItemDisplaySetting} />
                            </CheckboxTableRow>
                        </TableHead>
                        <TableBody loading={api.loading} columnLength={reagentItemDisplaySetting.getColumnLength() + 3}>
                            {api.response.results.map((reagentItem: ReagentItem) => {
                                return (
                                    <CheckboxTableRow
                                        key={`reagent-item-${reagentItem.id}`}
                                        item={reagentItem}
                                        multipleCheckForm={multipleCheckForm}
                                        onClickEdit={() => handleClickEdit(reagentItem)}
                                    >
                                        <ActionTableCell
                                            action="edit"
                                            onClick={() => {
                                                setSelectedReagentItem(reagentItem)
                                                setShowEdit(true)
                                            }}
                                        />
                                        <ReagentItemTableData
                                            reagentItem={reagentItem}
                                            displaySetting={reagentItemDisplaySetting}
                                            showRegentName={!query.reagentId || query.reagentId.split(',').length !== 0}
                                        />
                                    </CheckboxTableRow>
                                )
                            })}
                        </TableBody>
                    </ExTable>
                    <Pagination pageSet={api.pageSet} response={api.response}></Pagination>
                </TableWrapper>
            </ContentBody>

            <SelectionFixedFooter
                ids={multipleCheckForm.ids()}
                onClickReset={() => multipleCheckForm.form.resetForm()}
                searchForm={searchForm}
                searchAttr="id"
                tableName="RegentItem"
            >
                <Button
                    variant="success"
                    onClick={() => {
                        mergeReagentItemForm.update((f) => {
                            f.mergeSourceIds = multipleCheckForm.ids() as number[]
                        })
                        setShowMerge(true)
                    }}
                    disabled={multipleCheckForm.ids().length < 2}
                >
                    選択した試薬から新しい試薬を作成する
                </Button>
            </SelectionFixedFooter>
        </>
    )
}

export default withRouter(ReagentItemsPage)
